export default {
    memberOf: null,
    subscriptions: null,
    colors: null,
    transparent_header: false
}
